import React from 'react';
import PropTypes from 'prop-types';
import StyledFilter from './filter.style';

import FilterInput from './components/FilterInput';
import FilterDates from './components/FilterDates';
import FilterClearButton from './components/FilterClearButton';
import FilterContentTypes from './components/FilterContentTypes';

const Filter = ({ searchTerms = [], className }) => {
  return (
    <StyledFilter className={className}>
      <FilterInput searchTerms={searchTerms} />
      <FilterDates />
      <FilterContentTypes />
      <FilterClearButton />
    </StyledFilter>
  );
};

Filter.propTypes = {
  searchTerms: PropTypes.arrayOf(PropTypes.shape()),
  className: PropTypes.string
};

export default Filter;
